import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
const InsertElement = ({ item, Component }) => {
    const [element, setElement] = useState();
    useLayoutEffect(() => {
        const element = document.getElementById(`${item.builder.form.id}_${item.config.insertId}`);
        setElement(element);
    }, []);
    if (!element) {
        return null;
    }
    return createPortal(_jsx(Component, { "$element": item }), element);
};
const Elements = ({ $element }) => {
    var _a;
    if (!Array.isArray((_a = $element === null || $element === void 0 ? void 0 : $element.elements) === null || _a === void 0 ? void 0 : _a.elements)) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(_Fragment, { children: $element.elements.elements.map((item, index) => {
            const Component = item.variantConfig.Component;
            if (item.config.insertId) {
                return _jsx(InsertElement, { item: item, Component: Component }, index);
            }
            return _jsx(Component, { "$element": item }, index);
        }) }));
};
export default observer(Elements);
